module.exports = __webpack_public_path__ + "img/tiff.a05fc11a.svg";